var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"p-2 fullwidth"},[_c('div',{staticStyle:{"font-size":"2em","text-align":"center"}},[_c('b-spinner',{staticStyle:{"width":"2rem","height":"2rem"},attrs:{"variant":"success","type":"grow","label":"Spinning"}}),_vm._v(" "+_vm._s(_vm.$t("app.core.loading"))+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }